import { configureStore } from "@reduxjs/toolkit";
import { panelApi } from "./api";

/**
 * Creates the Redux store: the RTK Query cache (reducer and middleware).
 * Tests call it too, so every store is set up the same way.
 */
export const makeStore = (preloadedState) =>
  configureStore({
    reducer: { [panelApi.reducerPath]: panelApi.reducer },
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }).concat(panelApi.middleware),
    devTools: !import.meta.env.PROD, // Redux DevTools only in dev
  });
